var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouverify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 52,
    viewBox: "0 0 142 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.208 50.6401L139.053 40.7436C140.845 39.5245 141.921 37.5165 141.921 35.3651V6.53625C141.921 2.95057 139.053 0.0820312 135.467 0.0820312H6.45422C2.86854 0.0820312 0 2.95057 0 6.53625V35.8671V38.7356V45.1899C0 48.7755 2.86854 51.6441 6.45422 51.6441H120.622C121.913 51.7158 123.204 51.3572 124.208 50.6401Z",
    fill: "#46B2C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2392 12.9907L19.291 28.9828V38.8076H16.781V28.9828L12.1196 12.9907H14.7013L18.0001 24.4649L21.5858 12.9907H24.2392Z",
    fill: "#C7E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3628 16.3608V35.4366C37.3628 37.1577 36.072 38.592 34.3508 38.8071C34.2074 38.8071 34.1357 38.8071 33.9923 38.8071H29.546C29.4026 38.8071 29.2592 38.8071 29.1874 38.8071C27.4663 38.592 26.1755 37.1577 26.1755 35.4366V16.3608C26.1755 14.4962 27.6815 12.9902 29.546 12.9902H33.9923C35.8568 12.9902 37.3628 14.4962 37.3628 16.3608ZM34.8528 16.3608C34.8528 15.8588 34.4225 15.5002 33.9923 15.5002H29.546C29.044 15.5002 28.6855 15.9305 28.6855 16.3608V35.4366C28.6855 35.9386 29.1157 36.2971 29.546 36.2971H33.9923C34.4943 36.2971 34.8528 35.8669 34.8528 35.4366V16.3608Z",
    fill: "#C7E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1318 35.7951C51.1318 37.3011 49.9844 38.592 48.4784 38.8071C48.3349 38.8071 48.2632 38.8071 48.1198 38.8071H42.8847C42.7413 38.8071 42.6696 38.8071 42.5261 38.8071C41.0202 38.592 39.8727 37.3728 39.8727 35.7951V12.9902H42.3827V35.7951C42.3827 36.082 42.5979 36.2971 42.8847 36.2971H48.1198C48.4067 36.2971 48.6218 36.082 48.6218 35.7951V12.9902H51.1318V35.7951Z",
    fill: "#C7E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9605 36.2976C61.6736 37.7319 60.4545 38.7359 59.0202 38.7359C57.586 38.7359 56.3668 37.7319 56.08 36.2976V36.2259L53.2831 12.9907H55.7931L58.5182 35.8674C58.5899 36.1542 58.8051 36.2259 59.0202 36.2259C59.2354 36.2259 59.4505 36.1542 59.5222 35.8674L62.3191 12.9907H64.829L61.9605 36.2976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4904 15.5002V27.5481H74.0801V30.0581H69.4904V36.2971H77.0204V38.8071H66.9805V12.9902H76.9487V15.5002H69.4904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9368 38.8071H88.9248L82.9726 29.8429C82.6857 29.9146 82.3989 29.9864 82.112 29.9864V38.8071H79.6021V16.3608C79.6021 14.4962 81.108 12.9902 82.9726 12.9902H87.4188C89.2834 12.9902 90.7894 14.4962 90.7894 16.3608V20.0899C90.7894 23.9624 88.5662 27.3329 85.3391 28.9824L91.9368 38.8071ZM82.112 27.4764C85.626 26.9027 88.3511 23.819 88.3511 20.0899V16.3608C88.3511 15.8588 87.9208 15.5002 87.4905 15.5002H83.0443C82.5423 15.5002 82.1837 15.9305 82.1837 16.3608L82.112 27.4764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4468 12.9902H96.9568V38.8071H94.4468V12.9902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.407 15.5002V27.5481H106.997V30.0581H102.407V38.8071H99.8971V12.9902H109.865V15.5002H102.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.347 12.9902L118.399 28.9824V38.8071H115.889V28.9824L111.228 12.9902H113.809L117.108 24.4644L120.694 12.9902H123.347Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.993,
    height: 51.6338,
    fill: "white",
    transform: "translate(0 0.0820312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouverify);
export default __webpack_public_path__ + "static/media/youverify.3f97dd2ba9eea25729001810a7d39c13.svg";
export { ForwardRef as ReactComponent };